import React from 'react';
import { ToolComponentProps } from './types';
import { ChevronRight, ChevronDown } from 'lucide-react';
import { truncatePath } from './pathUtils';

export const ViewFileTool: React.FC<ToolComponentProps> = ({ 
  input, 
  output, 
  isError,
  isExpanded,
  onToggle 
}) => {
  const path = input?.path || '';
  const displayPath = truncatePath(path);
  const hasOutput = output !== undefined && output !== null;

  return (
    <div>
      <div
        className={`flex items-center gap-1 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
        title={path} // Show full path on hover
      >
        <span className="flex-1">Read: {displayPath}</span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-2 rounded ${isError ? 'bg-destructive/10 text-destructive' : 'bg-muted'} overflow-x-auto`}>
          <pre className="whitespace-pre">
            {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};